import React, { PureComponent } from 'react';
import { Button, Card, ExpansionList } from 'react-md';
import qs from 'qs';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { withRouter } from 'react-router';
import { orderBy } from 'lodash/collection';

import { invokeBackendApi } from '../../libs/awsLib';

import EditablePanel from './EditablePanel';
import ViewOnlyPanel from './ViewOnlyPanel';

export default withRouter(injectIntl(class FollowUpTab extends PureComponent {
  static propTypes = {
    intl: intlShape.isRequired,
    location: PropTypes.object.isRequired,
    userAttributes: PropTypes.shape({
      isPsy: PropTypes.bool.isRequired,
    }).isRequired,
  };
  constructor(props) {
    super(props);

    this.state = {
      followUps: [],
      isLoading: true,
    };
  }

  componentDidMount() {
    this.loadFollowUps();
  }

  loadFollowUps = () => {
    const { userAttributes: { isPsy } } = this.props;
    this.followUps()
      .then((followUpsFromDB) => {
        const followUps = (followUpsFromDB.length === 0 && isPsy)
          ? [{}]
          : orderBy(followUpsFromDB, 'createTime', 'desc');
        this.setState({ isLoading: false, followUps });
      })
      .catch(e => alert(e));
  }

  followUps = () => {
    const { location: { search } } = this.props;
    const { driver } = qs.parse(search.replace('?', ''));
    const path = driver ? `/drivers/${driver}/followUps` : '/followUps';
    return invokeBackendApi({ path });
  }

  handleClickNew = () => {
    this.setState({ isLoading: false, followUps: [{}, ...this.state.followUps] });
  }

  render() {
    const { intl, userAttributes, userAttributes: { isPsy } } = this.props;
    const { followUps, isLoading } = this.state;
    console.log('followUps', followUps);
    const editableRows = isPsy ? 1 : 0;

    return (
      // <span>These are the statistics</span>
      <Card style={{ height: 'calc(100vh - 140px - 14px)' }}>
        <div className="md-text-right">
          {isPsy &&
            <Button
              flat
              primary
              swapTheming
              iconChildren="add"
              style={{ marginTop: '15px' }}
              onClick={() => this.handleClickNew()}
              className="md-cell--middle newButton"
            >
              {intl.formatMessage({ id: 'followUp.buttons.new' })}
            </Button>}
        </div>
        {!isLoading &&
          <ExpansionList>
            {followUps.map((f, index) => ((index < editableRows)
              ? (<EditablePanel {...f} first={index === 0} key={f.createTime} />)
              : (<ViewOnlyPanel userAttributes={userAttributes} key={f.createTime} {...f} first={index === 0} />)))
            }
          </ExpansionList>
        }
      </Card>
    );
  }
}));



// WEBPACK FOOTER //
// ./src/components/FollowUp/index.js